import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { NgxPermissionsService } from 'ngx-permissions';

@Injectable({
  providedIn: 'root'
})
export class PermissionGuard implements CanActivate {

  constructor(
    private permissionsService: NgxPermissionsService,
    private router: Router
  ) {}

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {

    const requiredPermission = route.data['permission'];

    if (!requiredPermission) return true;

    const hasPermission = await this.permissionsService.hasPermission(requiredPermission);

    if (hasPermission) {
      return true;
    }

    this.router.navigate(['/pages/error-404']);
    return false;
  }
}